import { memo } from 'react';
import type { ThemeSpaces } from '@frameio/vapor';
import type { TrackTabSelected } from '../../../../shared/contexts/SearchAnalyticsContext/types';
import type { SectionId } from '../../../../shared/types';
import type { QuickSearchResultTypes } from '../../shared/QuickSearchResultTypes';
import { AssetListItem } from './AssetListItem';
import { ProjectListItem } from './ProjectListItem';

type Props = {
  isActive?: boolean;
  isCompact?: boolean;
  itemId: string;
  itemPosition: number;
  itemType: QuickSearchResultTypes;
  paddingInlineEnd?: ThemeSpaces;
  sectionId?: SectionId;
  tabSelected?: TrackTabSelected;
};

export const QuickSearchListItem = memo(
  ({
    isActive,
    isCompact = false,
    itemId,
    itemPosition,
    itemType,
    paddingInlineEnd,
    sectionId,
    tabSelected,
  }: Props) => {
    switch (itemType) {
      case 'AssetResult':
        return (
          <AssetListItem
            assetId={itemId}
            isActive={isActive}
            isCompact={isCompact}
            itemPosition={itemPosition}
            paddingInlineEnd={paddingInlineEnd}
            sectionId={sectionId}
            tabSelected={tabSelected}
          />
        );
      case 'ProjectResult':
        return (
          <ProjectListItem
            isActive={isActive}
            isCompact={isCompact}
            itemPosition={itemPosition}
            paddingInlineEnd={paddingInlineEnd}
            projectId={itemId}
            sectionId={sectionId}
            tabSelected={tabSelected}
          />
        );
      default:
        return null;
    }
  }
);

QuickSearchListItem.displayName = 'QuickSearchListItem';
